

export default {
    SET_TOTAL(state, payload){
        state.totalRecords = payload
    },
}
